module.exports = __webpack_public_path__ + "img/add.b0c43562.png";